module.exports = __webpack_public_path__ + "static/media/multi_user_mode.673304e3.jpeg";